<div
  *ngIf="!isLoading; else loadingAccordion"
  class="accordion_wrapper container"
  [style.padding]="storybook ? '2rem' : '0'"
  id="download-accordion"
>
  <h3 *ngIf="title">{{ title }}</h3>
  <div
    [ngClass]="{ active: isOpen[i], grey: !isSectionBg }"
    class="accordion"
    *ngFor="let accordionItem of accordionItems; let i = index"
    [id]="accordionItem.key"
  >
    <hdi-icon
      *ngIf="hasIcon"
      class="accordion_icon"
      [iconName]="getIcon(accordionItem.icon)"
    ></hdi-icon>
    <span
      class="accordion_title"
      [ngClass]="{ 'accordion_title--no-icon': !hasIcon }"
      (click)="toggleOpenClose(i)"
      (keydown)="handleEventDown($event)"
    >
      {{ accordionItem.name }}
    </span>
    <hdi-button
      class="accordion_btn"
      [label]="headerLabel | capitalize"
      [type]="accordion"
      [isOpen]="isOpen[i]"
      [iconName]="isOpen[i] ? 'minus' : 'plus'"
      (click)="toggleOpenClose(i)"
      (keydown)="handleEventDown($event)"
    >
    </hdi-button>
    <div
      [ngClass]="{ active: isOpen[i], grey: !isSectionBg }"
      class="accordion_content"
    >
      <div class="accordion_spacer"></div>
      <ng-container *ngFor="let utilitiesCards of utilitiesCardsList">
        <hdi-utilities-cards
          *ngIf="utilitiesCards.key === accordionItem.key"
          [utilitiesCards]="utilitiesCards"
          [backgroundColor]="isSectionBg ? 'white' : 'grey'"
        ></hdi-utilities-cards>
      </ng-container>
      <ng-container *ngFor="let item of accordionItem.content">
        <ng-container [ngSwitch]="item.template.uid">
          <hdi-text-block
            *ngSwitchCase="'st_text'"
            [caasData]="item"
          ></hdi-text-block>

          <hdi-static-graphic
            *ngSwitchCase="'st_image'"
            [caasData]="item"
          ></hdi-static-graphic>

          <ng-container *ngSwitchCase="'st_linklist'">
            <hdi-multimedia-list [caasData]="item"></hdi-multimedia-list>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!-- Loading Placeholder  -->
<ng-template #loadingAccordion>
  <div class="accordion_wrapper container">
    <div class="accordion accordion--loader">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          'margin-bottom': '0',
          'background-color': isSectionBg ? '#f9f9fa' : '#eff1f6',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>
